import 'css-chunksrc/client/common/elementAttachments/documentCard/styles.scss';export default {
  "card": "_card_1fhxz_1",
  "actions": "_actions_1fhxz_15",
  "preview": "_preview_1fhxz_19",
  "info": "_info_1fhxz_27",
  "name": "_name_1fhxz_32",
  "date": "_date_1fhxz_41",
  "actionIconBox": "_actionIconBox_1fhxz_60",
  "actionIcon": "_actionIcon_1fhxz_60",
  "removeIcon": "_removeIcon_1fhxz_80"
};